export default {
  htmlEl: document.documentElement,
  bodyEl: document.body,
};
